module.exports = __webpack_public_path__ + "media/images/icons/search-e2af0d3792246377ea647862921288ed.svg";